// extracted by mini-css-extract-plugin
module.exports = {"marketingExpertiseList":"style_marketingExpertiseList__EhpFz"};